import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBarDesktop";
import StoreApi from "../../service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";

export const NguonVon = () => {
  const initPhanQuyen = {
    quanlynguonvon_danhsachnguonvon: false,
    quanlynguonvon_gopvon: false,
    quanlynguonvon_rutvon: false,
    quanlynguonvon_suanguonvon: false,
    quanlynguonvon_themmoinguonvon: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenNguonVon().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        quanlynguonvon_danhsachnguonvon:
          response.data.quanlynguonvon_danhsachnguonvon,
        quanlynguonvon_gopvon: response.data.quanlynguonvon_gopvon,
        quanlynguonvon_rutvon: response.data.quanlynguonvon_rutvon,
        quanlynguonvon_suanguonvon: response.data.quanlynguonvon_suanguonvon,
        quanlynguonvon_themmoinguonvon:
          response.data.quanlynguonvon_themmoinguonvon,
      });
    });
  };

  useEffect(() => {
    document.title = "Nguồn vôn | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.quanlynguonvon_danhsachnguonvon && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-nguon-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Nguồn Vốn</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                  </div>{" "}
                </div>
                {/* <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull title="" icon1="fas fa-donate font-menu" />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <TableDanhSach
            themmoinguonvon={phanQuyen.quanlynguonvon_themmoinguonvon}
            quyenGopVon={phanQuyen.quanlynguonvon_gopvon}
            quyenRutVon={phanQuyen.quanlynguonvon_rutvon}
            quyenSuaNguonVon={phanQuyen.quanlynguonvon_suanguonvon}
          />
        </div>
      )}
      {!phanQuyen.quanlynguonvon_danhsachnguonvon && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Nguồn Vốn"
                      icon1="fas fa-donate font-menu"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
